// @ts-nocheck
import url from 'url'

const isRelative = (href: string): boolean => /^\.\.?(\/|$)/.test(href)
const hasExtension = (href: string): boolean => /\.[^/.]+$/.test(href)

export const stripLeadingSlash = (href: string) => href.replace(/^\/+/, '')
export const stripTrailingSlash = (href: string) => href.replace(/\/+$/, '')

const normalizePathnameSlashPrefix = (href: string): string => {
  if (href === '') {
    return ''
  }
  if (/^\/+$/.test(href)) {
    return '/'
  }

  const slashlessHref = stripLeadingSlash(href)
  if (isRelative(slashlessHref)) {
    return slashlessHref
  }
  return `/${slashlessHref}`
}

const normalizePathnameSlashSuffix = (href: string): string => {
  if (href === '') {
    return ''
  }
  if (/^\/+$/.test(href)) {
    return '/'
  }

  const slashlessHref = stripTrailingSlash(href)
  if (hasExtension(slashlessHref)) {
    return slashlessHref
  }
  return `${slashlessHref}/`
}

const normalizeSearchQuery = (searchQuery: unknown): string => {
  return searchQuery === '?' ? '' : searchQuery
}

const normalizeHash = (hash: unknown): string => {
  return hash === '#' ? '' : hash
}

export const normalizeUrl = (href: string | URL | unknown): string | null => {
  if (href instanceof URL) {
    return normalizeUrl(href.toString())
  }

  if (typeof href !== 'string') {
    return null
  }

  if (href.trim() === '') {
    return ''
  }

  const {
    hostname,
    pathname: oldPathname,
    search: oldSearch,
    hash: oldHash,
    ...urlRest
  } = url.parse(href)

  let newPathname = normalizePathnameSlashPrefix(
    normalizePathnameSlashSuffix(oldPathname || '')
  ).replace(/\/{2,}/g, '/')

  if (newPathname === '/' && hostname) {
    newPathname = ''
  }

  const newSearch = normalizeSearchQuery(oldSearch)
  const newHash = normalizeHash(oldHash)

  return url.format({
    hostname,
    pathname: newPathname,
    search: newSearch,
    hash: newHash,
    ...urlRest,
  })
}

export const getAbsoluteUrl = (baseHref: string, href: string): string => {
  const { host, protocol } = url.parse(baseHref)

  if (!host || !protocol) {
    throw new Error('baseHref is invalid')
  }

  return url.format({
    ...url.parse(href),
    protocol,
    host,
  })
}

export const hasQueryParams = (urlString: string): boolean => {
  const { query } = url.parse(urlString)

  return Boolean(query?.length)
}

export const setHash = (urlString: string, hash: string): string =>
  urlString
    ? url.format(Object.assign(url.parse(urlString), { hash }))
    : urlString
